export default function emptyListResponse() {
  return Promise.resolve({
    metadata: {
      total: 0,
      offset: 0,
      limit: 0,
    },
    items: [],
  });
}
